import type {
  AssignmentLatestCompletionReport,
  PlanUserSummaryReport,
} from '@cfa/pathway-fe-shared/xp';

interface PlanWithSummaries {
  id: string;
  activeCertificates: number;
  latestSummaryReports?: PlanUserSummaryReport[];
  type?: string;
}

const isExpirationInFuture = (expirationDate: string): boolean => {
  const expirationMs = Date.parse(expirationDate);
  if (Number.isNaN(expirationMs)) return false;
  return expirationMs >= Date.now();
};

export const hasValidCompletionReport = (
  report: AssignmentLatestCompletionReport | undefined,
) =>
  !!report &&
  (!report.expirationDate || isExpirationInFuture(report.expirationDate));

export const selectPlanCertificateCount = (
  data: PlanWithSummaries[],
  planId: string | null | undefined,
) => data.find(p => p.id === planId)?.activeCertificates ?? 0;

export const isActiveCertificate = (
  status: string | undefined,
  completionReport: AssignmentLatestCompletionReport | undefined,
  isMyPlansRoute: boolean,
) => {
  if (isMyPlansRoute) return status === 'COMPLETED';
  return hasValidCompletionReport(completionReport);
};

export const selectIntersectionCount = (
  data: PlanWithSummaries[],
  planId: string | null | undefined,
  teamMemberId: string,
  isMyPlansRoute: boolean,
) => {
  const plan = data.find(p => p.id === planId);
  const summary = plan?.latestSummaryReports?.find(
    r => r.userId === teamMemberId,
  );
  if (!summary) return 0;
  return isActiveCertificate(
    summary.status,
    summary.latestCompletionReport,
    isMyPlansRoute,
  )
    ? 1
    : 0;
};
